module.exports = __webpack_public_path__ + "media/music/punchy_bass_1-e09e1dd1.mp3";